import { useDeviceContext } from 'src/context/device.context';
import DesktopHeader from 'src/components/common/header/desktop';
import { useAuthContext } from 'src/context/auth.context';
import MobileHeader from 'src/components/common/header/mobile';

type HeaderProps = {
  onMenuToggle: () => void;
};

export const Header = ({ onMenuToggle }: HeaderProps) => {
  const { user, logout } = useAuthContext();
  const { isMobile } = useDeviceContext();

  if (isMobile) {
    return (
      <MobileHeader user={user} logout={logout} onMenuToggle={onMenuToggle} />
    );
  }

  return <DesktopHeader user={user} logout={logout} />;
};

export default Header;
